// src/shared/components/ImageModal/index.js
import React from 'react';
import { Modal, Image } from 'react-bootstrap';
import PropTypes from 'prop-types';
import './styles.css';

const ImageModal = ({ show, imageSrc, onClose }) => {
    return (
        <Modal
            show={show}
            onHide={onClose}
            centered
            animation={false}
            size="lg"
            dialogClassName="image-modal-dialog"
        >
            <Modal.Body className="modal-body-no-padding">
                <div className="image-container">
                    {imageSrc && (
                        <Image
                            src={imageSrc}
                            alt="Enlarged view"
                            className="modal-image"
                            fluid
                        />
                    )}
                </div>
            </Modal.Body>
        </Modal>
    );
};

ImageModal.propTypes = {
    show: PropTypes.bool.isRequired,
    imageSrc: PropTypes.string,
    onClose: PropTypes.func.isRequired
};

export default ImageModal;